export default __webpack_public_path__ + "img/loading-floors.svg";